import { getConnectionStatus } from '../services/connectionStatus';

/**
 * Si una impresión va por la nube o por el equipo (Print Agent / Bluetooth).
 *
 * La nube necesita servidor **y que la orden exista en él**. Una orden tomada sin conexión
 * (folio "SIN RED n") se imprime siempre por el equipo, aunque la red ya haya vuelto y
 * todavía no se sincronice: el trabajo de impresión en la nube apunta a una orden que el
 * servidor no conoce.
 *
 * Se decide al momento de imprimir, no al pintar la pantalla: entre el clic y la respuesta
 * la conexión puede cambiar, y una orden que cayó a la cola offline con el botón pulsado
 * "en línea" mandaba su comanda a la nube, donde nunca salía (docs/modo-offline.md).
 */
export const shouldUseCloudPrint = (
  cloudPrintSettingOn: boolean,
  order?: { offlineFolioLabel?: string } | null
): boolean => cloudPrintSettingOn && !order?.offlineFolioLabel && getConnectionStatus() === 'online';
